import { render } from "./SFormElementNumberInput.vue?vue&type=template&id=54956aef"
import script from "./SFormElementNumberInput.vue?vue&type=script&lang=js"
export * from "./SFormElementNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__